import React, { useState, useCallback, useEffect } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    FormHelperText,
    Select,
    FormControl,
    InputLabel,
    InputAdornment,
    MenuItem,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Button,
    Stack,
    Avatar,
    IconButton,
    Chip,
    styled,
    Container,
    ListItem,
    ListItemButton,
    List
} from '@mui/material';

import { useNavigate, useParams } from "react-router-dom";

import { useItems, itemTypes, targetTypes as itemTargetTypes } from "../../../hooks/api/useItems";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useAppContextFeatures } from '../../../context/AppContext';
import { CommonIcons, icons } from '../../common/CommonIcons'
import { useSystemUtils } from "../../../hooks/useSystemUtils";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import CommonBreadcumbs from "../../common/CommonBreadcumbs";
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonRestricted from "../../common/CommonRestricted";

import useUomView from "../../../hooks/sections/useUomView";

export const StyledIcon = styled(Box)({
    width: 100,
    height: 100,
    opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    minHeight: 450
}));

const StyledLabel = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    fontWeight: 800
}))

const StyledContent = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem'
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1,
    mb: 0,
    borderStyle: 'dashed'
}))

export default function ViewProduct({
    routeType
}) {

    const { id } = useParams();

    const { promptMessage } = useSystemPrompt();
    const { isLoading, get } = useItems({ itemType: itemTypes.product, targetType: itemTargetTypes.product });
    const { setSystemLoading } = useAppContextFeatures();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.product.id, scopeTypes.product.product.id)

    const { currencyAbb } = useSystemUtils();

    const { UomView, openView } = useUomView({
        handleOnCancel: () => { }
    });

    const navigate = useNavigate();

    const [data, setData] = useState()
    const [dialogOpen, setDialogOpen] = useState(false)
    const [dialogData, setDialogData] = useState(false)

    const loadData = useCallback(async (id) => {

        setSystemLoading(true);

        try {

            const { data } = await get({ id })
            // console.log('response?.data?.items', response?.data)
            setData(data)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }, [id])

    useEffect(() => {

        loadData(id);

    }, [])

    const RenderInfoForm = () => {

        if (!data?.product) return <></>

        const { product } = data;

        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Information`}
                            subTitle={`Detail information described the products`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Name</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {product.item_name}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Description</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {product.description}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Model</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {product.modal}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Summary</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {product.summary}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Brand</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {product.brand_name}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Category</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {product.category_name}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Status</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {
                                        Boolean(product.status) ? "ACTIVE" : "IN-ACTIVE"
                                    }
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderEmptyUom = () => {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2
                }}
            >
                <StyledIcon>
                    <CommonIcons name={icons.disabled} />
                </StyledIcon>
            </Box>
        )
    }

    const RenderUomForm = () => {

        if (!data?.items) return <></>

        const { items: uoms } = data;

        return (
            <StyledCard
                sx={{
                    pl: 0,
                    pr: 0
                }}
            >
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"} sx={{ ml: 3, mr: 3 }}>

                        <CommonSectionHeader
                            title={`Available UOM`}
                            subTitle={`Showing total ${uoms.length} variants`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item md={12}>

                        {
                            uoms && uoms.length <= 0 ?
                                (
                                    <RenderEmptyUom />
                                )
                                :
                                (
                                    <List
                                        sx={{
                                            // display: 'flex',
                                            // flexDirection: 'column',
                                            // flex: 1,
                                            flexGrow: 1,
                                            // height: 400,
                                            maxHeight: 500,
                                            // backgroundColor: 'red',
                                            // alignItems: 'flex-start',
                                            // justifyContent: 'flex-start',
                                            overflow: "hidden",
                                            overflowY: "scroll",
                                        }}
                                    >
                                        {
                                            uoms.map((item, index) => <RenderUomFormRow key={index} item={item} />)
                                        }
                                    </List>
                                )

                        }


                        {/* <RenderEmptyUom /> */}


                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderUomFormRow = ({ item }) => {
        return (
            <ListItem
                // key={index}
                disablePadding
            >
                <ListItemButton
                    role={undefined}
                    sx={{
                        // backgroundColor: 'red',
                    }}
                    onClick={() => {
                        openView({ data: item, open: true, id: 'viewUom' })
                    }}
                    dense
                >
                    {/* {item?.id} */}
                    <Grid container spacing={0.5}>
                        <Grid item md={1.5} xs={1.5} sm={1.5} sx={{ mr: 1 }}>
                            <StyledIcon
                                sx={{
                                    width: 50,
                                    height: 50
                                }}
                            >
                                <CommonIcons name={icons.products} />
                            </StyledIcon>
                        </Grid>
                        <Grid item md={6} xs={6} sm={6} flexGrow>
                            <Typography
                                sx={{
                                    fontSize: '1rem',
                                    fontWeight: 800
                                }}
                            >
                                {item?.uom_name}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: '0.7rem',
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {item?.code}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: '0.7rem',
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {currencyAbb} {item?.uom_price}
                            </Typography>

                        </Grid>
                        <Grid item md={4} xs={4} sm={4} textAlign={"right"}>

                            <Chip
                                label={item?.status ? 'ACTIVE' : 'IN-ACTIVE'}
                                color={item?.status ? 'primary' : 'error'}
                                fontSize="small"
                            />

                            {/* <UpdateUomInfo
                                id={"updateUomInfo"}
                                handleOnCancel={() => {}}
                                handleOnSelect={({ id, item }) => {
                                    console.log('id', id, item)
                                    // setFieldValue('location', item?.location_name)
                                }}
                                textProps={{
                                    disabled: true,
                                    value: "", //values?.location,
                                    error: "" //Boolean(errors?.location),
                                    // helperText: errors?.location,
                                }}
                            />
                            
                            <UpdateUomImages
                                id={id}
                                handleOnCancel={() => {}}
                                handleOnSelect={({ id, item }) => {
                                    console.log('id', id, item)
                                    // setFieldValue('location', item?.location_name)
                                }}
                                textProps={{
                                    disabled: true,
                                    value: "", //values?.location,
                                    error: "" //Boolean(errors?.location),
                                    // helperText: errors?.location,
                                }}
                            />

                            <UpdateUomScan
                                id={"updateUomScan"}
                                handleOnCancel={() => {}}
                                handleOnSelect={({ id, item }) => {
                                    console.log('id', id, item)
                                    // setFieldValue('location', item?.location_name)
                                }}
                                textProps={{
                                    disabled: true,
                                    value: "", //values?.location,
                                    error: "" //Boolean(errors?.location),
                                    // helperText: errors?.location,
                                }}
                            /> */}

                        </Grid>
                    </Grid>

                </ListItemButton>

            </ListItem>
        )
    }

    const RenderNewForm = () => {
        return (
            <Grid container spacing={1} textAlign={"left"}>
                <Grid item md={7}>
                    <RenderInfoForm />
                </Grid>
                <Grid item md={5}>
                    <RenderUomForm />
                </Grid>

                {/* Updated */}
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"center"}>
                        <Button
                            type="button"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 2,
                                mb: 2
                            }}
                            // loading={isLoading}
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

        )
    }

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id })) {
            props.push({
                displayText: "Edit Item",
                href: getRoute(`product/item/update/${id}`),
            })
        }

        return props

    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.viewItem })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle="View Item"
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: "Items",
                        props: {
                            href: getRoute("products/items")
                        }
                    },
                    {
                        displayText: "View Item",
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {/* <CommonBreadcumbs
                routeType={routeType}
                pageTitle="Product"
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: "Products",
                        props: {
                            href: getRoute('products/items')
                        }
                    },
                    {
                        displayText: "View Product",
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            /> */}

            {/* <RenderNewForm /> */}

            {
                isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                    RenderNewForm()
                    :
                    <CommonRestricted />
            }

            {
                UomView()
            }

        </Box>
    )
}